import { LocalStorageService } from './../../../../core/services/local-storage.service';
import { environment } from './../../../../../environment/environment';
import { SortDataService } from './../../../../core/services/sortdata';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import {
  EmptyCV,
  obligationSelect,
  serverError,
} from './../../../../core/models/messages';
import { EsnCandidatService } from './../../../../core/services/esn-candidat/esn-candidat.service';
import { EsnJobOfferService } from './../../../../core/services/esn-job-offer-service/esn-job-offer.service';
import { SalarieService } from './../../../../core/services/salarie-service/salarie.service';
import { Country, IState, State } from 'country-state-city';
import * as saveAs from 'file-saver';
import * as JSZip from 'jszip';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { translations } from '../../../../core/models/call-offer';

@Component({
  selector: 'app-suggestion-offers',
  templateUrl: './suggestion-offers.component.html',
  styleUrls: ['./suggestion-offers.component.css'],
})
export class SuggestionOffersComponent {
  isFormSubmitted: boolean = false;
  freeSearch: boolean = false;
  isFreeSearchFromSubmitted: boolean = false;
  activeForm: 'freeSearch' | 'guidedSearch' | null = null;

  toggleCollapsible() {
    this.isCollapsed = !this.isCollapsed;
  }
  contrat = [
    { id: 1, name: 'Alternance' },
    { id: 2, name: 'Autres type de contrat' },
    { id: 3, name: 'CDD' },
    { id: 4, name: 'CDI' },
    { id: 5, name: 'Freelance' },
    { id: 6, name: 'Portage salarial' },
    { id: 7, name: 'Stage' },
  ];
  Statut: { id: string; name: string }[] = [
    { id: '1', name: 'actif' },
    { id: '2', name: 'inactif' },
  ];
  profile = [
    { id: 1, name: 'Oui' },
    { id: 0, name: 'Non' },
  ];
  passeport = [
    { id: 1, name: 'Oui' },
    { id: 0, name: 'Non' },
  ];
 disponibilite = [
    { id: 1, name: 'Immédiate' },
    { id: 3, name: '2 mois' },
    { id: 4, name: '3 mois' },
    { id: 5, name: '4 mois' },
    { id: 6, name: '5 mois' },
  ];
  poste = [
    { id: 1, name: 'A distance' },
    { id: 2, name: 'Hybride' },
    { id: 3, name: 'Sur site' },
  ];
  searchForm: FormGroup = this.createSearchForm();
  freeSearchForm: FormGroup = this.createFreeSearchForm();

  idoffre = this.activatedRoute.snapshot.params['id'];
  connectedUser = this.localStorageService.getData('userConnected');
  loadSpinner: boolean = false;
  idappel: any;
  itemsPerPage: number = 5;
  currentPage: number = 1;
  currentSortDirection: number = 1;
  startIndex: number = 0;
  endIndex: number = 5;
  totalItems!: number;
  listappeloffre: any;
  sortAttr = '';
  urlimage: string = environment.baseUrlGalery;
  urlcv: string = environment.baseUrlGaleryCv;
  url: string = environment.baseUrl + '/api';
  loadSpinnerTable: boolean = false;
  pagination : boolean =false;

  currentSortColumn: string = 'name';
  seeMore: boolean = false;
  paysList: any[] = Country.getAllCountries().map((country) => ({
    ...country,
    name: this.translateCountryName(country.name),
  }));
  countries: any = [];
  stateList!: IState[];
  backGroundColors: string[] = [
    'blue',
    'orange',
    'bleu-clair',
    'pink',
    'rose',
    'jaune',
    'rouge',
  ];
  selectedUserId!: string;
  nameEsn = this.localStorageService.getData('clientConnectedName');
  idclientConnected: any;
  isCollapsed = true;
  iduser: any;

  skillsList: { name_FR: string }[] = [];
  listsuggestion: any;
  ischecked = true;
  selectedCandidats: any = [];

  startSearching:boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private jobofferservice: EsnJobOfferService,
    private spinner: NgxSpinnerService,
    private toastrService: ToastrService,
    private sortDataService: SortDataService,
    private salarieservice: SalarieService,
    private activatedRoute: ActivatedRoute,
    private candidatservice: EsnCandidatService,
    private localStorageService: LocalStorageService
  ) {}
  ngOnInit() {
    this.idclientConnected =
      this.localStorageService.getData('clientConnected');
    this.countries = Country.getAllCountries();
    this.getListSkills();
    this.getListsuggestion();
  }
  // sortData(item:string){
  //   this.currentSortDirection = this.currentSortDirection === 1 ? 2 : 1;
  //   this.sortAttr=item
  //   // let sort={sort:this.currentSortDirection,sortAttribute:item}
  //   // console.log("sort",sort)
  //   if(this.searchForm.value!='') this.listappeloffre = this.sortDataService.sortArray(this.listappeloffre, this.sortAttr, this.currentSortDirection)
  //   else this.getListappeloffre()
  // }
  getItems(event?: any) {
    if ((event && event.startIndex != this.startIndex) ||
    this.endIndex != event.endIndex ||
    this.itemsPerPage != event.itemsPerPage ||
    this.currentPage != event.currentPage) {
      this.startIndex = event.startIndex;
      this.endIndex = event.endIndex;
      this.itemsPerPage = event.itemsPerPage;
      this.currentPage = event.currentPage;
      if (this.isFormSubmitted) {
        this.searchsuggestion(this.currentPage);
      } else if(this.isFreeSearchFromSubmitted){
        this.searchsuggestion(1);
      } else {
        this.getListsuggestion();
      }
    }
  }

  translateCountryName(name: string): string {

    return translations[name] || name;
  }
  onCountryChange(event: any): void {
    if (event) {
      this.stateList = State.getStatesOfCountry(event.isoCode);
      for (const iterator of this.stateList) {
        iterator.name = iterator.name.replace(' Governorate', '');
      }
    } else {
      this.stateList = [];
      this.searchForm.get('city')?.setValue(null);
    }
  }
  getListSkills() {
    this.salarieservice.getSkills().subscribe({
      next: (res) => {
        this.skillsList = res.data;
      },
      error: () => {
        this.toastrService.error(serverError);
      },
    });
  }

  getListsuggestion() {
    let dataPyload =
      this.sortAttr == ''
        ? {
            job_offer_id: this.idoffre,
            esn_id: this.idclientConnected,
            per_page: this.itemsPerPage,
            page: this.currentPage,
          }
        : {
            ...{
              job_offer_id: this.idoffre,
              esn_id: this.idclientConnected,
              per_page: this.itemsPerPage,
              page: this.currentPage,
            },
            ...{
              sort: this.currentSortDirection,
              sortAttribute: this.sortAttr,
            },
          };
    this.spinner.show();
    this.jobofferservice.getListsuggestionjoboffer(dataPyload).subscribe({
      next: (response: any) => {
        if (response.data && response.data.data) {

          const { to, from, total, current_page, data } = response.data;
          this.spinner.hide();
          this.currentPage = current_page;
          this.endIndex = to;
          this.totalItems = total;
          this.listsuggestion = data

        }
      },
      error: (error: any) => {
        this.spinner.hide();
      },
    });
  }

  sortData(item: string) {
    this.currentSortDirection = this.currentSortDirection === 1 ? 2 : 1;
    let sort = { sort: this.currentSortDirection, sortAttribute: item };
    this.sortAttr = item;
    this.currentPage = 1;
    this.endIndex = 5;
    if (this.isFormSubmitted) {
      this.searchsuggestion(this.currentPage);
    }else if(this.isFreeSearchFromSubmitted){
      this.freeSearchsuggestion(this.currentPage);
    }else{
      this.getListsuggestion();
    }
  }


  onSalaryRangeInput(event: any) {
    const value = event.target.value;
    if (value.toLowerCase().endsWith('k')) {
      this.searchForm.controls['desired_salary_range'].setValue(
        this.convertKToNumber(value)
      );
    }
  }

  convertKToNumber(value: any) {
    if (typeof value === 'string' && value.toLowerCase().endsWith('k')) {
      return parseFloat(value.slice(0, -1)) * 1000;
    } else if (!isNaN(value)) {
      return parseFloat(value) * 1000;
    }
    return parseFloat(value);
  }
  createSearchForm(data?: any) {
    return this.formBuilder.group({
      name: ['', data?.name],
      post: ['', data?.post],
      skillsOr: [[], data?.skillsOr],
      skillsAnd: [[], data?.skillsAnd],
      manager_name: ['', data?.manager_name],
      client_final_name: ['', data?.client_final_name],
      desired_salary: ['', data?.desired_salary],
      desired_salary_range: ['', data?.desired_salary_range],
      tjm_vente: ['', data?.tjm_vente],
      tjm_vente_range: ['', data?.tjm_vente_range],
      tjm_achat: ['', data?.tjm_achat],
      tjm_achat_range: ['', data?.tjm_achat_range],
      max_experience_years: ['', data?.max_experience_years],
      min_experience_years: ['', data?.min_experience_years],
      mobility: [[], data?.mobility],
      country: [null, data?.country],
      per_page: this.itemsPerPage,
      page: this.currentPage,
    });
  }

  createFreeSearchForm(data?: any) {
    return this.formBuilder.group({
      search: [
        '',
        [Validators.pattern(/^("([^"]*"(AND|NOT|,|&&)[^"]*)*"|[^\s"']+)$/)],
      ],
    });
  }

  setActiveForm(form: 'freeSearch' | 'guidedSearch') {
    // Si aucun formulaire n'est actif, activer le formulaire cliqué
    if (this.activeForm === null) {
      this.activeForm = form;

      // Désactiver le formulaire non actif
      if (form === 'freeSearch') {
        this.freeSearchForm.enable(); // Activer le formulaire libre
        this.searchForm.disable(); // Désactiver le formulaire guidé
      } else if (form === 'guidedSearch') {
        this.searchForm.enable(); // Activer le formulaire guidé
        this.freeSearchForm.disable(); // Désactiver le formulaire libre
      }
    }
  }

  resetFreeSearch() {
    this.currentPage = 1;
    this.freeSearchForm.reset();
    this.freeSearchForm = this.createFreeSearchForm();
    this.freeSearchForm.get('search')?.reset();
    this.isFreeSearchFromSubmitted = false;
  }

  resetAdvancedSearch() {
    this.currentPage = 1;
    this.searchForm.reset();
    this.isFormSubmitted = false;
  }

  onReset() {
    this.resetFreeSearch();
    this.resetAdvancedSearch();
    this.activeForm = null;
    this.currentPage = 1;
    this.getListsuggestion();
  }

  displayFreeSearch() {
    this.freeSearch = !this.freeSearch;
    if(this.freeSearch) {
       this.searchForm = this.createSearchForm();
       this.searchForm.reset();
       this.getListsuggestion();
       this.activeForm = 'freeSearch';
    }
    else {
      this.freeSearchForm.reset();
      this.freeSearchForm = this.createFreeSearchForm();
      this.getListsuggestion();
      this.activeForm = 'guidedSearch'
    }
  }

  freeSearchsuggestion(pageNumber: number = this.currentPage) {
    this.isFormSubmitted = false;
    this.isFreeSearchFromSubmitted = true;
    let valueForm = this.freeSearchForm.value;

    let data = {
      sort: this.currentSortDirection,
      sortAttribute: this.sortAttr ?? 'id',
      page: pageNumber,
      per_page: this.itemsPerPage,
      search: this.transformSearch(valueForm?.search),
    }
    this.spinner.show();
    this.jobofferservice.searchconsultantsuggestionofferemploi(data).subscribe({
          next: (resSearch) => {
              const { to, from, total, current_page, data } = resSearch.data;
              this.spinner.hide();
              this.currentPage = current_page;
              this.endIndex = to;
              this.startSearching = false;
              this.listsuggestion = data;
              this.totalItems = total;
              this.spinner.hide();
          },
          error: (error) => {
              this.spinner.hide();
          },
      });
  }

  /* search */
  searchsuggestion(pageNumber : number = this.currentPage) {
    let valueForm = this.searchForm.value;
    valueForm.desired_salary_range = this.convertKToNumber(
      valueForm.desired_salary_range.toString()
    );
    let data = {
      name: valueForm.name,
      post: valueForm.post,
      skillsOr: valueForm.skillsOr,
      skillsAnd: valueForm.skillsAnd,
      manager_name: valueForm.manager_name,
      client_final_name: valueForm.client_final_name,
      tjm_achat: valueForm.tjm_achat,
      tjm_achat_range: valueForm.tjm_achat_range,
      tjm_vente: valueForm.tjm_vente,
      tjm_vente_range: valueForm.tjm_vente_range,
      desired_salary: this.searchForm.value.desired_salary,
      desired_salary_range: this.searchForm.value.desired_salary_range,
      max_experience_years: valueForm.max_experience_years,
      min_experience_years: valueForm.min_experience_years,
      mobility: valueForm.mobility,
      country: valueForm.country,
      per_page: this.itemsPerPage,
      page: pageNumber,

      job_offer_id: this.idoffre,
      esn_id: this.idclientConnected,
    };

    this.spinner.show();
    this.jobofferservice.searchconsultantsuggestionofferemploi(data).subscribe({
      next: (resSearch) => {
        if(this.startSearching == true) {
          this.currentPage = 1;
          this.startSearching = false;
        }
          this.listsuggestion = resSearch.data.data.slice(0, this.endIndex);
          this.totalItems = resSearch.data.total;
          this.spinner.hide();
      },
      error: (error) => {
        this.toastrService.error(serverError);
        this.spinner.hide();
      },
    });
  }
  reset() {
    this.searchForm.reset();
    this.searchForm = this.createSearchForm();
    this.searchsuggestion();
  }
  transformSearch(search: string): string {
    // Remplace toutes les occurrences de '||' par 'OR'
    search = search.replace(/\|\|/g, ' OR ');

    // Remplace toutes les occurrences de '&&' par ' AND '
    search = search.replace(/&&/g, ' AND ');

    // Remplace toutes les occurrences de '!' par ' NOT '
    search = search.replace(/!/g, ' NOT ');

    // Ajoute des espaces autour des opérations logiques pour éviter des conflits avec les mots
    search = search.replace(/\b(AND|OR|NOT)\b/g, ' $1 ');

    // Remplace les termes entre guillemets doubles par les mêmes termes sans modification
    // et échappe les guillemets simples à l'intérieur des termes non compris entre guillemets
    search = search.replace(/"([^"]+)"|(\S+)/g, (match, p1, p2) => {
      if (p1) {
        return `"${p1}"`;
      } else {
        // Si le terme n'est pas entre guillemets, échappe les guillemets simples à l'intérieur du terme
        const escapedTerm = p2.replace(/"/g, '\\"');
        return `${escapedTerm}`;
      }
    });

    // Supprime les espaces en double pour une meilleure lisibilité
    search = search.replace(/\s+/g, ' ');

    // Renvoie la chaîne de recherche transformée
    return search.trim();
  }

  isSimpleWord(value: string): boolean {
    const simpleWordPattern = /^[a-zA-Z0-9]+(\s[a-zA-Z0-9]+)?$/;
    return simpleWordPattern.test(value);
  }
  downloadFile(type: string, candidat?: any, typeFile?: string) {
    if (this.ischecked) {
      if (type == 'single' && candidat) {
        if (candidat.cv || candidat.file_test) {
          if (typeFile && typeFile != '')
            candidat.file_test = candidat.file_test.split('/')[1];
          const fileUrl = !typeFile
            ? `${this.url}/User/file/gallery_cvs/${candidat.cv}`
            : `${this.url}/ResponseCandidate/GetFile/${candidat.file_test}`; // Replace with your file URL
          this.showGlobalSpinner();
          this.candidatservice.downloadPDF(fileUrl).subscribe(
            (data) => {
              const blob = new Blob([data], {
                type: 'application/octet-stream',
              });
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = !typeFile
                ? `${candidat.ID_user}_${candidat.first_name}_${
                    candidat.last_name
                  }_CV.${candidat!.cv.split('.').pop()}`
                : `${candidat.ID_user}_${candidat.first_name}_${
                    candidat.last_name
                  }_QCM.${candidat!.file_test.split('.').pop()}`;
              document.body.appendChild(a);
              a.click();
              window.URL.revokeObjectURL(url);
              this.hideGlobalSpinner();
            },
            () => {
              this.hideGlobalSpinner();
            }
          );
        } else {
          this.toastrService.info(EmptyCV);
        }
      } else if (this.selectedCandidats.length) {
        if (
          this.selectedCandidats.length == 1 &&
          !this.selectedCandidats[0].cv
        ) {
          this.toastrService.info(EmptyCV);
        } else this.downloadPdfFiles(typeFile);
      } else {
        this.toastrService.info(obligationSelect);
      }
    } else {
      this.toastrService.error(
        'Limite de téléchargements atteinte. Vous ne pouvez télécharger que 3 fichiers.'
      );
    }
  }
  showGlobalSpinner() {
    this.loadSpinner = true;
    this.spinner.show();
  }
  hideGlobalSpinner() {
    this.loadSpinner = false;
    this.spinner.hide();
  }
  /* download files in zip folder */
  downloadPdfFiles(typeFile?: string) {
    const zip = new JSZip();
    const fileUrls = this.selectedCandidats.map(
      (el: {
        cv: string;
        file_test: string;
        first_name: string;
        last_name: string;
        ID_user: string;
      }) => {
        if (!typeFile) {
          return {
            url: `${this.url}/User/file/gallery_cvs/${el.cv}`,
            first_name: el.first_name,
            last_name: el.last_name,
            ID_user: el.ID_user,
            cv: el.cv,
          };
        } else {
          // if(el.file_test!=null)
          return {
            url: `${this.url}/ResponseCandidate/GetFile/${
              el?.file_test?.split('/')[1]
            }`,
            first_name: el.first_name,
            last_name: el.last_name,
            ID_user: el.ID_user,
            response: el?.file_test?.split('/')[1],
          };
        }
      }
    );
    this.showGlobalSpinner();
    const downloadPromises = fileUrls.map((pdfUrl: any) => {
      return this.candidatservice
        .getPdfContent(pdfUrl.url)
        .toPromise()
        .then(
          (pdfContent: any) => {
            this.hideGlobalSpinner();
            zip.file(
              !typeFile
                ? `${pdfUrl.ID_user}_${pdfUrl.first_name}_${
                    pdfUrl.last_name
                  }_CV.${pdfUrl.cv.split('.').pop()}`
                : `${pdfUrl.ID_user}_${pdfUrl.first_name}_${
                    pdfUrl.last_name
                  }_QCM.${pdfUrl.response.split('.').pop()}`,
              pdfContent
            );
          },
          (err: any) => {
            this.hideGlobalSpinner();
          }
        );
    });

    Promise.all(downloadPromises).then(() => {
      zip.generateAsync({ type: 'blob' }).then((content) => {
        if (!typeFile) {
          saveAs(content, 'RH_Profiles_CVs.zip'); // Specify the zip file name here
        } else {
          saveAs(content, 'RH_Profiles_QCMs.zip');
        }
      });
    });
  }
}
